import { z } from 'zod';
/**
 * Standard API Response wrapper
 * All API responses should follow this format
 */
export const ApiResponseSchema = (dataSchema) => z.object({
    success: z.boolean(),
    data: dataSchema.optional(),
    message: z.string().optional(),
    error: z
        .object({
        code: z.string(),
        message: z.string(),
        details: z.record(z.string(), z.unknown()).optional(),
    })
        .optional(),
    meta: z
        .object({
        timestamp: z.string().datetime(),
        requestId: z.string().optional(),
    })
        .optional(),
});
/**
 * Pagination request parameters
 */
export const PaginationParamsSchema = z.object({
    page: z.coerce.number().int().positive().default(1),
    limit: z.coerce.number().int().positive().max(100).default(20),
    sortBy: z.string().optional(),
    sortOrder: z.enum(['asc', 'desc']).default('desc'),
});
/**
 * Pagination response metadata
 */
export const PaginationMetaSchema = z.object({
    page: z.number().int().positive(),
    limit: z.number().int().positive(),
    total: z.number().int().nonnegative(),
    totalPages: z.number().int().nonnegative(),
    hasNext: z.boolean(),
    hasPrev: z.boolean(),
});
/**
 * Paginated response wrapper
 */
export const PaginatedResponseSchema = (itemSchema) => z.object({
    items: z.array(itemSchema),
    pagination: PaginationMetaSchema,
});
/**
 * Common ID schema (UUID)
 */
export const IdSchema = z.string().uuid();
/** Provider-independent file URL accepted by persisted resource fields. */
export const HttpOrInternalFileUrlSchema = z
    .string()
    .min(1)
    .max(2048)
    .refine((value) => /^https?:\/\//i.test(value) ||
    /^\/api\/v1\/files\/[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}\/serve(?:\?.*)?$/i.test(value), 'must be an http(s) URL or a canonical internal file path');
/**
 * Common date schemas
 */
export const DateTimeSchema = z.string().datetime();
export const DateSchema = z.string().date();
/**
 * Common status enum
 */
export const StatusSchema = z.enum(['active', 'inactive', 'pending', 'deleted']);
/**
 * Sort order enum
 */
export const SortOrderSchema = z.enum(['asc', 'desc']);
//# sourceMappingURL=common.js.map